<template>
  <div :class="classObj" class="app-wrapper">
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <!--是否固定  -->
      <div :class="{ 'fixed-header': fixedHeader }">
        <!--面包屑-->
        <navbar />
        <!-- 快捷标签页面-->
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
    </div>
    <!--  系统信息弹框  -->
    <transition name="el-zoom-in-bottom">
      <SysInfo
        v-if="getmessageShow.messageInfo"
        :key="getmessageShow.messageInfo"
        :message-obj="getmessageShow"
        :message-show="getmessageShow.messageInfo"
      />
    </transition>
    <accountCPFTip ref="cpfFromRef" />
    <WarningTrajectoryTip ref="trajectoryRef" />
  </div>
</template>

<script>
import { AppMain, Navbar, Sidebar } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import TagsView from './components/TagsView';
import SysInfo from '@/components/sysInfo/index.vue';
import accountCPFTip from '@/components/accountCPFTip/index.vue';
import WarningTrajectoryTip from '@/components/WarningTrajectoryTip/index.vue';
import { getExpressWmsLink } from '@/api/serialPort';
import { checkCPFValidity } from '@/api/user';
import dayjs from 'dayjs';

export default {
  name: 'Layout',
  components: {
    accountCPFTip,
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    SysInfo,
    WarningTrajectoryTip
  },
  mixins: [ResizeMixin],
  data() {
    return {
      checkCPFValidityObj: {},
      trajectoryTimer: null
      // getmessageShow: false
    };
  },
  computed: {
    needTagsView() {
      return this.$store.state.settings.tagsView;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    getmessageShow() {
      return this.$store.state.user.getmessageShowObj;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile' // 开启这在页面缩小到一定程度后就隐藏菜单栏
      };
    }
  },
  created() {
    getExpressWmsLink().then((res) => {
      console.log(res.installer);
      this.$store.dispatch('app/updateExpressWmsPluginLink', res?.installer);
    });
  },
  mounted() {
    this.getCheckCPFValidity();
    const isTrajectoryRequested = localStorage.getItem('isTrajectoryFirstLoad') || 'false';
    if (isTrajectoryRequested !== 'true') {
      localStorage.setItem('isTrajectoryFirstLoad', 'true');
      this.getTrajectoryData(); // 仅登录首次执行，弹框只出一次
    }
    this.initTrajectoryTimer();
  },
  beforeDestroy() {
    this.trajectoryTimer && clearInterval(this.trajectoryTimer);
  },
  methods: {
    // 获取用户的cpf
    async getCheckCPFValidity() {
      const res = await checkCPFValidity();
      this.checkCPFValidityObj = res.data;
      if (this.checkCPFValidityObj && this.checkCPFValidityObj.resultCode === 2) {
        this.$refs.cpfFromRef.showCpf(this.checkCPFValidityObj);
      }
    },
    // 获取用户的cpf
    getTrajectoryData() {
      // 是否存在付款按钮权限，只有存在一个权限就会显示
      const buttonPermissions = this.$store.getters.button_permissions;
      const isFlage = buttonPermissions.includes('alert:customer-track-stationary');
      console.log('isFlage', isFlage);
      if (isFlage) {
        this.$refs.trajectoryRef.showTrajectory();
      }
    },
    initTrajectoryTimer() {
      this.trajectoryTimer && clearInterval(this.trajectoryTimer);
      this.trajectoryTimer = setInterval(() => {
        console.log('initTrajectoryTimer定时器');
        const now = dayjs();
        if (now.minute() === 0 && [9, 16, 17, 18, 19].includes(now.hour())) this.getTrajectoryData();
      }, 60000);
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
